(function ($) {

    $(window).on('load', function () {
        console.log("1")

        var $counter = $('.counter');
        if ($counter.length) {
            $counter.each(function () {
                var $thisCounter, $progress, $count, percent, r, c, total, range;

                $thisCounter = $(this);

                percent = $thisCounter.find('.counter__area').data('percent');

                $progress = $thisCounter.find('.counter__progress');

                $count = $thisCounter.find('.counter__content');

                r = $progress.attr('r');

                c = Math.PI * (r * 2);

                total = percent > 100 ? Math.ceil(percent / 100) * 100 : 100;

                range = ((total - percent) / 100) * c;

                $progress.css({
                    'stroke-dashoffset': c,
                    'stroke-dasharray': c,
                });

                new Waypoint({
                    element: this,
                    handler: function (direction) {
                        if (direction === 'down') {
                            $progress.animate(
                                {
                                    strokeDashoffset: range,
                                },
                                3000,
                                'linear'
                            );

                            if (!isNaN(parseInt($thisCounter.find('.counter__content').text(), 10))) {
                                $count.prop('Counter', 0).animate(
                                    {
                                        Counter: percent,
                                    },
                                    {
                                        duration: 3000,
                                        step: function (now) {
                                            // return $(this).text(text(parseFloat(now).toFixed(1)));
                                        },
                                    }
                                );
                            }
                        }
                    },
                    offset: '75%'
                });
            });
        }
    });


    $(window).on('load', function () {
        $('.counting').each(function () {
            var $this = $(this),
                countTo = $this.find(".counter__content").html();

            $({countNum: $this.text()}).animate({
                    countNum: countTo
                },

                {

                    duration: 3000,
                    easing: 'linear',
                    step: function () {
                        $this.find(".counter__content").text(Math.floor(this.countNum));
                    },
                    complete: function () {
                        $this.find(".counter__content").text(this.countNum);
                    }

                });
        });
    });
})(jQuery);
